import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

// Components
import { CarouselArrows, CarouselContent, CarouselDots } from ".";

export const Carousel = ({
  images,
  optimizedImages = null,
  size = "medium",
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Support both legacy (images function) and new (optimizedImages array) formats
  const imageData =
    optimizedImages || (typeof images === "function" ? images() : images || []);
  const len = imageData.length - 1;

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(activeIndex === len ? 0 : activeIndex + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, [activeIndex, len]);

  if (imageData.length === 0) {
    return (
      <div className="slider_container">
        <div className="no-images-placeholder">
          <p>No images available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="slider_container">
      <CarouselContent
        activeIndex={activeIndex}
        sliderImage={optimizedImages ? () => imageData : images}
        optimizedImages={optimizedImages}
        size={size}
      />
      <CarouselArrows
        prevSlide={() =>
          setActiveIndex(activeIndex < 1 ? len : activeIndex - 1)
        }
        nextSlide={() =>
          setActiveIndex(activeIndex === len ? 0 : activeIndex + 1)
        }
      />
      <CarouselDots
        activeIndex={activeIndex}
        sliderImage={optimizedImages ? () => imageData : images}
        onclick={(activeIndex) => setActiveIndex(activeIndex)}
      />
    </div>
  );
};

Carousel.propTypes = {
  images: PropTypes.func, // Legacy: function returning image URL strings
  optimizedImages: PropTypes.array, // New: array of carouselOptimized objects
  size: PropTypes.oneOf(["small", "medium", "large"]),
};
